import pdfWorkerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { pdfjs } from 'react-pdf';

import { Providers } from './app/providers';
import { Router } from './app/router';

import './index.css';

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerSrc;

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <Providers>
      <Router />
    </Providers>
  </StrictMode>,
);
